module.exports = __webpack_public_path__ + "img/popup-bg_GT.19ecce7.png";